import { useCallback, useEffect, useState } from "react";

export interface DraftSubmissionFormData {
  authId: string;
  portalName: string;
  jCodes: string[];
  filePath: string;
  comments: string;
}

export interface ErrorStates {
  authId: boolean;
  portalName: boolean;
  jCodes: boolean;
  filePath: boolean;
}

export const useDraftSubmissionFormDataWithErrorStates = (
  selectedJCodeId: string,
) => {
  const [formData, setFormData] = useState<DraftSubmissionFormData>({
    authId: "",
    portalName: "",
    jCodes: [],
    filePath: "",
    comments: "",
  });

  const [errorStates, setErrorStates] = useState<ErrorStates>({
    authId: false,
    portalName: false,
    jCodes: false,
    filePath: false,
  });

  const validateFormData = useCallback(() => {
    setErrorStates({
      authId: !formData.authId,
      portalName: !formData.portalName,
      jCodes: formData.jCodes.length === 0,
      filePath: !formData.filePath,
    });
  }, [formData]);

  const checkIfFormDataIsInvalid = () => {
    return (
      !formData.authId ||
      !formData.portalName ||
      formData.jCodes.length === 0 ||
      !formData.filePath
    );
  };

  const updateFormDataWithPreSelectedJCodeValue = () => {
    if (selectedJCodeId) {
      setFormData((prevFormData: DraftSubmissionFormData) => ({
        ...prevFormData,
        jCodes: [selectedJCodeId],
      }));
    }
  };

  useEffect(() => {
    validateFormData();
  }, [formData]);

  useEffect(() => {
    updateFormDataWithPreSelectedJCodeValue();
  }, [selectedJCodeId]);

  return {
    formData,
    setFormData,
    errorStates,
    checkIfFormDataIsInvalid,
  };
};
